import React from "react";
import StableClaim from "./StableClaim";
// import { ClaimProps } from "@components/V2/Vault/Common/Claim";

/**
 * Wrapper component that makes the original StableClaim compatible with VaultDWB
 * This preserves all the original stable vault claim logic and UX
 * while conforming to the ClaimProps interface expected by VaultDWB
 */
// props: ClaimProps

// Memoize the StableClaim component to prevent unnecessary re-renders
const MemoizedStableClaim = React.memo(StableClaim);

const StableClaimWrapper = () => {
  // We ignore the props from VaultDWB and use the original StableClaim component directly
  // This ensures no changes to the existing claim logic or UX
  // const _props = props;
  return <MemoizedStableClaim />;
};

export default StableClaimWrapper;
